export default "__VITE_ASSET__ELhgCJ1S__"